import { useCallback, useState } from "react"
import whatInput from "what-input"

const specificKeyMap = {
  Tab: 9,
  Enter: 13,
  Escape: 27,
  "": 32, // Space
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
}

whatInput.specificKeys(Object.values(specificKeyMap))

const useFocusVisible = () => {
  const [isFocusVisible, setIsFocusVisible] = useState(false)

  const onFocus = useCallback(
    (e: React.FocusEvent) => {
      const isKeyboard = whatInput.ask("input") === "keyboard"

      if (
        !isFocusVisible &&
        // イベントリスナーを設定した要素とfocusイベントが発生した要素が一致してた場合
        e.currentTarget === e.target &&
        isKeyboard
      ) {
        setIsFocusVisible(true)
      }
    },
    [isFocusVisible]
  )

  const onBlur = useCallback(
    (e: React.FocusEvent) => {
      if (
        isFocusVisible &&
        // イベントリスナーを設定した要素とblurイベントが発生した要素が一致してた場合
        e.currentTarget === e.target
      ) {
        setIsFocusVisible(false)
      }
    },
    [isFocusVisible]
  )

  return {
    isFocusVisible,
    focusVisibleProps: {
      onFocus,
      onBlur,
    },
  }
}

export default useFocusVisible
